import { render, staticRenderFns } from "./personZhuce.vue?vue&type=template&id=376a18d3&scoped=true&"
import script from "./personZhuce.vue?vue&type=script&lang=js&"
export * from "./personZhuce.vue?vue&type=script&lang=js&"
import style0 from "./personZhuce.vue?vue&type=style&index=0&id=376a18d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a18d3",
  null
  
)

export default component.exports